<button mat-icon-button (click)="onClick()" (keydown.enter)="onClick()" mat-button matTooltip="Release notes">
    <mat-icon class="info-icon" svgIcon="information-outline"></mat-icon>
    <span class="notification-dot" [class.active]="displayNotification"></span>
</button>
